// extracted by mini-css-extract-plugin
export var center = "_1e-2";
export var clickableRow = "_1e-5";
export var expandedRow = "_1e-7";
export var hoverable = "_1e-4";
export var left = "_1e-1";
export var right = "_1e-3";
export var row = "_1e-0";
export var selectedRow = "_1e-6";
export var summaryRow = "_1e-8";